import { HubConnectionBuilder, HttpTransportType, HubConnection } from "@microsoft/signalr";
import { TokenService } from "../../../auth/tokenService";

(function (module) {
    "use strict";

    module.service("initializeReportHubService", [
        "$rootScope",
        "marketContentReportService",
        TokenService.componentName,
        function (
            this: $TSFixMe,
            $rootScope: ng.IRootScopeService,
            marketContentReportService: $TSFixMe,
            tokenService: TokenService
        ) {
            var service = this;
            var hubConnection: HubConnection;
            var marketContentReportGenerationIsFinished = true;

            service.initializeHub = function () {
                hubConnection = new HubConnectionBuilder()
                    .withUrl("/api/hubs/report", {
                        accessTokenFactory: () => tokenService.accessToken,
                        transport: HttpTransportType.WebSockets
                    })
                    .build();

                hubConnection.on("fileReadyToDownload", downloadReport);
                hubConnection.on("generateMarketContentStarted", reportGenerationIsStarted);
                hubConnection.on("generateMarketContentFinished", reportGenerationIsFinished);

                hubConnection.start();
            };

            service.getMarketContentReportGenerationIsFinished = function () {
                return marketContentReportGenerationIsFinished;
            };

            // @ts-expect-error ts-migrate(2454) FIXME: Variable 'reportGenerationIsFinished' is used befo... Remove this comment to see the full error message
            service.marketContentReportGenerationFailed = reportGenerationIsFinished;

            var downloadReport = function (model: $TSFixMe) {
                marketContentReportService.downloadReport(model);
            };

            var reportGenerationIsFinished = function () {
                marketContentReportGenerationIsFinished = true;
                $rootScope.$broadcast("market-content-report-generation-is-finished");
            };

            var reportGenerationIsStarted = function () {
                marketContentReportGenerationIsFinished = false;
                $rootScope.$broadcast("market-content-report-generation-is-started");
            };
        }
    ]);
    module.run([
        "initializeReportHubService",
        (service: $TSFixMe) => {
            service.initializeHub();
        }
    ]);
})(angular.module("topline.services"));
